import React, { useEffect, useMemo, useState } from "react";
import { InputTypeAhead, InputText } from "@loanbossinc/component-library";

import { dscrTypes, DSCR_TYPE_NAMES } from "./helpers";
import { InputGroup } from "./inputGroup";
import DscrFromFile from "./dscrFromFile";
import { useFlags } from "launchdarkly-react-client-sdk";
import { InputDropdownWrapper, InputGroupLabel, TypeSelectionContainer, SwitchWrapper, StyledLockedSwitch, SwitchLabelWrapper } from "./styles";

const SingleInlineInputField = ({ field, handleChange, calculationFieldsInputValues }) => {
  const { fieldName, fieldLabel } = field;

  const getValue = () => {
    if (!calculationFieldsInputValues || !calculationFieldsInputValues.length) {
      return "";
    }

    return calculationFieldsInputValues.find(f => f.fieldName === fieldLabel).inputValue;
  };

  return (
    <div style={{ width: "45%" }}>
      <InputText value={getValue()} variant="filled" id={fieldLabel} fullWidth name={fieldLabel} label={fieldName} onChange={handleChange} />
    </div>
  );
};

const DscrTypesSelectionsValue = (props) => {
  const {
    setDscrLineItemSelections,
    selectedDscrType,
    isEditing,
    lineItemType,
    activeLoanId,
    calculationFieldsInputValues,
    calculateMostRecentPayment,
    recentAsOfDate,
    setDscrCalculationDashboardSelections
  } = props;

  const { bar1540FromFileDscrCalculation } = useFlags();
  const [flaggedDscrTypes,setFlaggedDscrTypes] = useState(dscrTypes);
  const [shouldFocusOnOverrideInput, setShouldFocusOnOverrideInput] = useState(false);

  const onSelectTypeChange = (value) => {
    setDscrLineItemSelections({ selectedDscrType: value, calculationFieldsInputValues: null });
    if (value?.type === DSCR_TYPE_NAMES.MOST_RECENT_PAYMENT) {
      calculateMostRecentPayment({ loanId: activeLoanId, asOfDate: recentAsOfDate });
    }
  };

  const handleInputValueChange = (e) => {
    setShouldFocusOnOverrideInput(false);
    if (parseFloat(e.target?.value) < 0) {
      e.target.value = "";
    }
    const updatedValue =
      calculationFieldsInputValues &&
      calculationFieldsInputValues.map((field) => (field.fieldName === e.target.name ? { ...field, inputValue: e.target.value } : { ...field }));
    setDscrCalculationDashboardSelections({
      wasContentUpdated: true
    });
    setDscrLineItemSelections({ calculationFieldsInputValues: updatedValue, resultValue: null });
  };
  useEffect(()=>{
    if(!bar1540FromFileDscrCalculation){
      setFlaggedDscrTypes(flaggedDscrTypes.filter(dt => dt.type !== "From file"));
    }
  },[]);
  useEffect(() => {
    if (!isEditing) {
      const inputValuesMapping =
        selectedDscrType &&
        selectedDscrType.calculationFields &&
        selectedDscrType.calculationFields.map((calcField) => {
          const mapping = { fieldName: calcField.fieldLabel, inputValue: "" };
          if (calcField.additionalFields) {
            mapping.additionalInputValue = null;
          }
          if (calcField.includeToggle) {
            mapping.shouldOverrideRate = false;
          }

          return mapping;
        });
      setDscrLineItemSelections({ calculationFieldsInputValues: inputValuesMapping, resultValue: selectedDscrType?.value || null });
    } else {
      setDscrLineItemSelections({ isEditing: false });
    }
  }, [selectedDscrType]);

  useEffect(() => () => setDscrLineItemSelections({ calculationFieldsInputValues: null, selectedDscrType: null }), []);

  const fieldInputs = useMemo(() => {
    return flaggedDscrTypes.find((type) => type?.type === selectedDscrType?.type)?.calculationFields;
  }, [selectedDscrType?.type]);

  const toggleValue = useMemo(() => {
    return (
      calculationFieldsInputValues &&
      calculationFieldsInputValues.find((field) => field.fieldName === "override hypothetical amortization rate?")?.shouldOverrideRate
    );
  }, [calculationFieldsInputValues]);

  const onToggleChange = () => {
    const updatedValue = calculationFieldsInputValues.map((field) => (field.fieldName === "override hypothetical amortization rate?" ? { ...field, shouldOverrideRate: !toggleValue, inputValue: "" } : { ...field }));
    setDscrLineItemSelections({ calculationFieldsInputValues: updatedValue, resultValue: null });
    if (!toggleValue) {
      setShouldFocusOnOverrideInput(true);
    }
  };

  return (
    <>
      <TypeSelectionContainer>
        <InputDropdownWrapper>
          <InputTypeAhead
            variant="filled"
            id="typeId"
            name="dscrType"
            label="Select DS Type"
            options={flaggedDscrTypes}
            displayWith={(option) => option && option?.type}
            setValueWith={(option) => option}
            onChange={onSelectTypeChange}
            value={selectedDscrType}
          />
        </InputDropdownWrapper>
      {fieldInputs && fieldInputs.length === 1 && (
          <SingleInlineInputField field={fieldInputs[0]} handleChange={handleInputValueChange} calculationFieldsInputValues={calculationFieldsInputValues} />
        )}
      </TypeSelectionContainer>
      {selectedDscrType?.type === DSCR_TYPE_NAMES.FROM_FILE && <DscrFromFile calculationComponentType="regular" { ...props } /> }
      {fieldInputs &&
        fieldInputs.length > 1 &&
        fieldInputs.map((field) => {
          return (
            <>
            {field.includeToggle && (
              <SwitchLabelWrapper width="45%">
                <InputGroupLabel>{field.fieldLabel}</InputGroupLabel>
              <SwitchWrapper>
                <StyledLockedSwitch value={toggleValue} onChange={onToggleChange} />
              </SwitchWrapper>
              </SwitchLabelWrapper>
            )}
            <InputGroup
              key={field.fieldLabel}
              field={field}
              fullWidth={lineItemType === "greaterOf"}
              lineItemType={lineItemType}
              handleChange={handleInputValueChange}
              calculationFieldsInputValues={calculationFieldsInputValues}
              setDscrLineItemSelections={setDscrLineItemSelections}
              shouldFocusOnOverrideInput={shouldFocusOnOverrideInput}
            />
            </>
          );
        })}
    </>
  );
};

export default DscrTypesSelectionsValue;
